<div class="guard" *ngIf="isAllowed()">
    <ng-content></ng-content>
</div>